import { Box, Center, Flex, Text } from '@chakra-ui/react'
import { Loading } from '@components'
import { Check } from '@components/icons'
import { useWidget } from '@hooks'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSessionControllerGetProgressNotesForSession } from '~/clinician-api'

export const MiniWidgetNoteResult = () => {
  const { sessionId } = useParams<{ sessionId: string }>()
  const { settings } = useWidget()

  const { data: progressNoteData, isLoading: isProgressNotesLoading } =
    useSessionControllerGetProgressNotesForSession(sessionId, {
      query: {
        enabled: !!sessionId,
        refetchInterval: (data: any) => {
          if (
            data?.sessionProgressNotes.some((pn: any) => pn.note?.isLoading)
          ) {
            return 5000
          }

          return false
        }
      }
    })

  const isNoteLoading =
    progressNoteData?.sessionProgressNotes[0]?.note?.isLoading

  useEffect(() => {
    if (!isNoteLoading && !isProgressNotesLoading) {
      // eslint-disable-next-line
      parent.postMessage({ type: 'BP_NOTE_GENERATED', sessionId }, '*')
    }
  }, [isNoteLoading, isProgressNotesLoading])

  return (
    <Box
      bg={settings.minifiedViewSettings?.container?.backgroundColor ?? 'white'}
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      p="small"
    >
      {isProgressNotesLoading || isNoteLoading ? (
        <Center w="100%" h="100%">
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Loading
              color={
                settings?.minifiedViewSettings?.audioIndicatorColor ?? 'primary'
              }
            />
            <Text mt="xsmall">Generating note...</Text>
          </Flex>
        </Center>
      ) : (
        <Center h="100%" w="100%">
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Flex
              alignItems="center"
              justifyContent="center"
              w="40px"
              h="40px"
              bg="#3A6562"
              borderRadius="24px"
            >
              <Check width="24px" height="24px" fill="white" />
            </Flex>
            <Text mt="xsmall">Note Generated!</Text>
          </Flex>
        </Center>
      )}
    </Box>
  )
}
